import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaCity, FaEnvelope, FaPhone, FaHome, FaSave, FaEdit, FaCheckCircle, FaTruck } from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const CreateDistributor = ({ distributorData, onSave }) => {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    address: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (distributorData) {
      setFormData(distributorData);
    }
  }, [distributorData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Token tidak ditemukan. Harap login ulang.");
      return;
    }

    const requestBody = {
      name: formData.name,
      kota: formData.city,
      alamat: formData.address,
      telepon: formData.phone,
      email: formData.email,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/distributor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (response.ok) {
        console.log("Distributor Created:", result);
        if (typeof onSave === "function") {
          onSave(result);
        }
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate("/enterprise/distributor");
        }, 2000); // Redirect setelah 2 detik
      } else {
        console.error("Gagal membuat distributor:", result);
        alert(`Gagal: ${result.message || "Terjadi kesalahan."}`);
      }
    } catch (error) {
      console.error("Error saat submit:", error);
      alert("Terjadi kesalahan saat menghubungi server.");
    }
  };

  const isEdit = Boolean(distributorData);

  return (
    <>
      <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0">
        <PageCreateHeader
          icon={isEdit ? FaEdit : FaTruck}
          title={isEdit ? "Edit Distributor" : "Buat Distributor"}
          description={
            isEdit
              ? "Perbarui data distributor"
              : "Tambah distributor baru ke sistem"
          }
          breadcrumbs={[
            { label: "Enterprise", to: "/" },
            { label: "Distributor", to: "/enterprise/distributor" },
            { label: isEdit ? "Edit Distributor" : "Buat Distributor" },
          ]}
        />

        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 w-full">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-5">
          {/* Nama */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaUser className="text-gray-500" /> Nama
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Masukkan nama distributor"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          {/* Kota */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaCity className="text-gray-500" /> Kota
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Masukkan kota"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          {/* Alamat */}
          <div className="col-span-1 md:col-span-2 flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaHome className="text-gray-500" /> Alamat
            </label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Masukkan alamat lengkap"
              rows="3"
              className="p-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          {/* Email */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaEnvelope className="text-gray-500" /> Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Masukkan email"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          {/* No HP */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaPhone className="text-gray-500" /> No. HP
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Masukkan nomor HP"
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          {/* Tombol Simpan */}
          <div className="text-right mt-2">
            <button
              type="submit"
              className="px-6 py-3 bg-green-500 text-white font-semibold rounded-xl hover:bg-green-600 transition-all duration-200 inline-flex items-center gap-2"
            >
              <FaSave />
              {distributorData ? "Update" : "Simpan"}
            </button>
          </div>
        </form>
        </div>
      </div>

      {/* ✅ Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity">
          <div className="bg-white p-6 rounded-xl shadow-xl text-center animate-bounce-in">
            <FaCheckCircle className="text-green-500 text-4xl mx-auto mb-2" />
            <h2 className="text-lg font-semibold text-gray-800">Distributor berhasil ditambahkan!</h2>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateDistributor;
